import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetAppMessagePreferenceRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SetAppMessagePreferenceResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const setAppMessagePreference = (request: SetAppMessagePreferenceRequest, options?: CashRequestOptions) =>
  post<SetAppMessagePreferenceRequest, SetAppMessagePreferenceResponse>(
    '/2.0/cash/set-app-message-preference',
    request,
    { ...options, rejectOnError: true }
  )
